import { loadProfileInfo, updateProfileAddress, updateProfilePerson, nationalityIncorrectEmail } from './services'

const getDefaultState = () => {
  return {
    data: null
  }
}

const state = getDefaultState()

const actions = {

  async loadProfileInfoAction ({ dispatch, commit, rootState }) {
    const token = rootState.auth.token
    const userData = rootState.auth.userData

    const data = {
      bookno: userData.bookno,
      clientname: userData.name,
      custno: userData.custno,
      system: userData.system
    }

    dispatch('spinner/updateLoadingAction', true, { root: true })
    const res = await loadProfileInfo(token, data)
    commit('profileInfoReceived', res)

    dispatch('spinner/updateLoadingAction', false, { root: true })
  },

  async updateProfileAddressAction ({ dispatch, rootState }, values) {
    const token = rootState.auth.token
    const userData = rootState.auth.userData

    const data = {
      ADDRESS: [
        {
          addr1: values.addr1,
          addr2: values.addr2,
          addr3: values.addr3,
          postcode: values.postcode,
          custno: rootState.auth.userData.custno,
          editop: 'Y'
        }
      ],
      BOOKNO: userData.bookno,
      SYSTEM: userData.system
    }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    await updateProfileAddress(token, data)
    dispatch('spinner/updateLoadingAction', false, { root: true })
    dispatch('loadProfileInfoAction')
  },

  async updateProfilePersonAction ({ dispatch, rootState }, { person, values }) {
    const token = rootState.auth.token
    const userData = rootState.auth.userData

    const newValues = { ...person, ...values }
    const data = {
      PAXNAMES: newValues,
      BOOKNO: userData.bookno,
      SYSTEM: userData.system
    }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    await updateProfilePerson(token, data)
    dispatch('spinner/updateLoadingAction', false, { root: true })
    dispatch('loadProfileInfoAction')
  },

  async profileDeletePassportAction ({ dispatch, rootState }, person) {
    const token = rootState.auth.token
    const userData = rootState.auth.userData

    const newValues = {
      ...person,
      expiredate: '',
      ispermitted: 'Y',
      issauth: '',
      issuedate: '',
      nationality: '',
      nationalityCode: '',
      passport: '',
      pob: ''
    }
    const data = {
      PAXNAMES: newValues,
      BOOKNO: userData.bookno,
      SYSTEM: userData.system
    }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    await updateProfilePerson(token, data)
    dispatch('spinner/updateLoadingAction', false, { root: true })
    dispatch('loadProfileInfoAction')
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  },
    async nationalityChangeAction ({ dispatch, rootState }, person) {
        const token = rootState.auth.token
        const payload = {
        from: 'intranet@trailfinders.com',
        ieBooking: false,
        inc_awards: false,
        inc_headers_footers: false,
        send_to: 'watchreports@trailfinders.com',
        subject: `${rootState.auth.userData.bookno} - Nationality Change Notification for ${person.firstname + ' ' + person.surname}`,
        version: 1
        }
        const res = await nationalityIncorrectEmail(token, payload)
        if (res && res.response === '250 Message accepted for delivery') {
            dispatch('flashMessage/set', { type: 'success', message: 'Thank You! We will be in touch shortly.' }, { root: true })
        } else {
            dispatch('flashMessage/set', { type: 'error', message: 'There has been an issue with the request. Please contact your local Travel Centre.' }, { root: true })
        }
    }

}

const mutations = {
  profileInfoReceived (state, data) {
    state.data = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
